import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M9.274 12.47 5.632 8.83v3.263l2.884 2.884 4.08-.816 4.458 4.46 1.632-1.633-4.459-4.458.816-4.08-2.884-2.884H8.895l3.643 3.642-.545 2.72-2.72.544Z"
      clipRule="evenodd"
    />
  </svg>
);
